import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";
import { parseKeywordsFromText } from "@/utils/keywordInput";

interface AddKeywordBulkEntryTabProps {
  themeName: string;
  bulkText: string;
  bulkParsed: string[];
  onBulkTextChange: (text: string, parsed: string[]) => void;
  onRemoveParsed: (phrase: string) => void;
}

export function AddKeywordBulkEntryTab({
  themeName,
  bulkText,
  bulkParsed,
  onBulkTextChange,
  onRemoveParsed,
}: AddKeywordBulkEntryTabProps) {
  return (
    <div className="flex flex-col flex-1 min-h-0 px-6 py-4 gap-3 overflow-y-auto">
      <div className="space-y-2">
        <label htmlFor="bulk-keywords" className="text-sm font-medium">
          Paste keywords
        </label>
        <Textarea
          id="bulk-keywords"
          placeholder={"Enter keywords, one per line or comma-separated\n\nbeach bag\nwaterproof tote\nsummer accessories"}
          value={bulkText}
          onChange={(e) => onBulkTextChange(e.target.value, parseKeywordsFromText(e.target.value))}
          className="min-h-[140px]"
        />
        <p className="text-xs text-muted-foreground">
          New keywords are created in your Keyword Bank and added to the &ldquo;{themeName}&rdquo; theme
          once you click &ldquo;Add to {themeName}&rdquo; below.
        </p>
      </div>

      {bulkParsed.length > 0 && (
        <div className="space-y-2">
          <span className="text-xs text-muted-foreground">
            {bulkParsed.length} keyword{bulkParsed.length !== 1 ? "s" : ""} detected:
          </span>
          <div className="flex flex-wrap gap-2 max-h-[120px] overflow-y-auto">
            {bulkParsed.map((kw) => (
              <Badge key={kw} variant="secondary" className="text-xs pr-1">
                {kw}
                <button
                  onClick={() => onRemoveParsed(kw)}
                  className="ml-1 hover:bg-muted rounded-full p-0.5"
                >
                  <X className="h-3 w-3" />
                </button>
              </Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
